import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { trigger, state, style, transition, animate, query, stagger } from '@angular/animations';

interface TeamMember {
  name: string;
  position: string;
  image: string;
  description: string;
}

interface CompanyValue {
  icon: string;
  title: string;
  description: string;
}

interface CompanyStat {
  icon: string;
  number: string;
  label: string;
}

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(40px)' }),
        animate('800ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('slideInLeft', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-60px)' }),
        animate('1000ms 200ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(60px)' }),
        animate('1000ms 400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('staggerCards', [
      transition(':enter', [
        query('.stat-card, .value-card', [
          style({ opacity: 0, transform: 'translateY(40px) scale(0.9)' }),
          stagger(200, animate('600ms cubic-bezier(0.25, 0.8, 0.25, 1)',
            style({ opacity: 1, transform: 'translateY(0) scale(1)' })))
        ], { optional: true })
      ])
    ]),
    trigger('staggerTeam', [
      transition(':enter', [
        query('.team-card', [
          style({ opacity: 0, transform: 'translateY(40px) scale(0.9)' }),
          stagger(200, animate('600ms cubic-bezier(0.25, 0.8, 0.25, 1)',
            style({ opacity: 1, transform: 'translateY(0) scale(1)' })))
        ], { optional: true })
      ])
    ])
  ]
})
export class AboutComponent implements OnInit {
  stats: CompanyStat[] = [
    {
      icon: '🏢',
      number: '10+',
      label: 'Years Experience'
    },
    {
      icon: '🌍',
      number: '25+',
      label: 'Countries Served'
    },
    {
      icon: '🤝',
      number: '500+',
      label: 'Satisfied Clients'
    },
    {
      icon: '📦',
      number: '1000+',
      label: 'Products Supplied'
    }
  ];

  values: CompanyValue[] = [
    {
      icon: '🛡️',
      title: 'Reliability Guaranteed',
      description: 'Count on us for reliable and durable parts and products. We take pride in offering only the best, ensuring you experience optimal performance and peace of mind with every purchase.'
    },
    {
      icon: '💰',
      title: 'Value for Money',
      description: 'We understand the importance of affordability. That\'s why we strive to offer competitive prices without compromising on the quality of our products and services.'
    },
    {
      icon: '🚀',
      title: 'Convenient Access',
      description: 'With a focus on accessibility, we ensure that you can easily reach us and explore our wide range of solutions at your convenience.'
    }
  ];

  teamMembers: TeamMember[] = [
    {
      name: 'Mr. Vishal N Kale',
      position: 'Founder',
      image: "assets/vishal-sir.png",
      description: 'Visionary leader driving innovation and excellence in the goods and equipment industry with extensive business expertise.'
    },
    {
      name: 'Miss. Prerna Ashok Patil',
      position: 'Proprietor',
      image: "assets/girl.png",
      description: 'Dynamic proprietor focused on strategic growth and maintaining the highest standards of customer satisfaction and operational excellence.'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    // Component initialization logic
  }
}
